module.exports = __webpack_public_path__ + "static/media/login.ff1fb28a.svg";